import { IChatModsConfiguration, ConfigurationPaths } from '@/app-modules/config';

interface IArcadeGameConfiguration {
  skins: string[];
  bonusRounds: string[];
}

class ArcadeGameConfiguration implements IArcadeGameConfiguration {
  public readonly skins: string[];
  public readonly bonusRounds: string[];

  constructor(private readonly arcadeGameName: string, private readonly config: IChatModsConfiguration) {
    this.skins = this.loadSkinsFromConfig();
    this.bonusRounds = this.loadBonusRoundsFromConfig();
  }

  private loadSkinsFromConfig(): string[] {
    const configPaths = this.getConfigurationPaths();
    const skins = this.config.getConfigurationByPath(configPaths.skins);
    return skins ? skins.split(',').map((item) => item.trim()) : [];
  }

  private loadBonusRoundsFromConfig(): string[] {
    const configPaths = this.getConfigurationPaths();
    const bonusRounds = this.config.getConfigurationByPath(configPaths.bonusrounds);
    return bonusRounds ? bonusRounds.split(',').map((item) => item.trim()) : [];
  }

  private getConfigurationPaths() {
    return ConfigurationPaths.forArcadeGame(this.arcadeGameName);
  }
}

export { IArcadeGameConfiguration, ArcadeGameConfiguration };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/arcade-game/_domain/models/arcade-game.ts